import { SLOT_HEIGHT, SLOT_TIME, SLOT_TIME_SNAP, SLOT_SNAP, COLUMN_MARGIN } from "../../appointment-schedule.constants.js";
const getTimeSlotDiference = (y) => Math.floor(y / SLOT_HEIGHT * SLOT_TIME / SLOT_TIME_SNAP) * SLOT_TIME_SNAP;
const snapToGrid = (transform, draggingNodeRect) => {
  var _a;
  const X_ROW_OFFSET = 2 * COLUMN_MARGIN;
  const X_OFFSET = Math.ceil(((_a = draggingNodeRect == null ? void 0 : draggingNodeRect.current) == null ? void 0 : _a.offsetWidth) ?? 0) + X_ROW_OFFSET;
  const offset = (draggingNodeRect == null ? void 0 : draggingNodeRect.current) ? draggingNodeRect.current.offsetWidth / 2 : 0;
  const y = (transform == null ? void 0 : transform.y) ? Math.floor(transform.y / SLOT_SNAP) * SLOT_SNAP : 0;
  const x = (transform == null ? void 0 : transform.x) ? Math.floor((transform.x + offset) / X_OFFSET) * X_OFFSET : 0;
  const timeSlotDifference = transform ? getTimeSlotDiference(y) : 0;
  return { x, y, timeSlotDifference };
};
export {
  getTimeSlotDiference,
  snapToGrid
};
